module.exports = __webpack_public_path__ + "img/image (103).11bb774f.jpg";